import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { getVisitsByDateAndClientId } from '../../services/visits.service';
import { ACTION_ADD_PHOTO_COMMIT } from './photoActions';

export const fetchVisitsByDateAndClientId = createAsyncThunk(
  'visits/fetchVisitsByDateAndClientId',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getVisitsByDateAndClientId(payload);
      return response;
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);

export const postVisitAttachments = (visitId, visitData, clientId) => ({
  type: 'visit/postAttachments',
  payload: visitData,
  meta: {
    visitId,
    clientId,
    offline: {
      effect: {
        url: `/qac/visit-attachments/${visitId}`,
        method: 'PUT',
        data: visitData,
      },
      commit: {
        type: 'visit/postAttachments/commit',
        meta: {
          visitId,
          clientId,
        },
      },
      rollback: { type: 'visit/postAttachments/rollback', meta: { visitId } },
    },
  },
});

export const cancelVisitById = createAction(
  'visit/delete',
  function prepare(reportId, clientId, reportData) {
    return {
      payload: { reportId, clientId },
      meta: {
        offline: {
          effect: {
            url: `/qac/visit/cancel/${reportId}`,
            method: 'POST',
            data: reportData,
          },
          commit: {
            type: 'visit/cancel/commit',
            meta: {
              reportId,
              clientId,
            },
          },
          rollback: { type: 'visit/cancel/rollback', meta: { reportId } },
        },
      },
    };
  }
);

export const addAttachmentImage = createAction(
  'visit/addAttachmentImage',
  function prepare(
    clientId,
    reportId,
    reportDate,
    photo,
    source,
    onUploadProgress
  ) {
    const payload = {
      clientId,
      reportId,
      photo,
      visitDate: reportDate,
    };

    const { link: _, ...photoWithoutContent } = photo;
    let isStarted = false;

    return {
      payload,
      meta: {
        offline: {
          effect: {
            url: `/qac/attachment/photo/${photo.id}/${reportId}`,
            method: 'POST',
            data: {
              clientId,
              fileName: photo.fileName,
              imageBinary: photo.link,
              visitDate: reportDate,
            },
            onUploadProgress: (event) => {
              !isStarted &&
                onUploadProgress &&
                onUploadProgress(event, payload);
              isStarted = true;
            },
            cancelToken: source?.token,
          },
          commit: {
            type: ACTION_ADD_PHOTO_COMMIT,
            meta: {
              clientId,
              reportId,
              photo: photoWithoutContent,
              // after: applicationId ? undefined : fetchClientDataById,
              // afterArgs: [{ clientId }],
            },
          },
          rollback: {
            type: 'visit/addAttachmentImage/rollback',
            meta: { clientId, reportId, photo },
          },
        },
      },
    };
  }
);
